import API from "../API";

var Access = {
    async ListFacilityRoles(requester) {
        var result = await API.process(
            `api/Access/Roles${requester ? '?requester=' + requester : ''}`,
            'GET',
            null
        ).catch((err) => {
            throw err;
        })

        return result
    },
    async CreateFacilityRoles(Role) {
        var result = await API.process(
            'api/Access/Role',
            'POST',
            Role
        ).catch((err) => {
            throw err;
        })

        return result
    },
    async UpdateFacilityRoles(Role) {
        var result = await API.process(
            'api/Access/Role',
            'PUT',
            Role
        ).catch((err) => {
            throw err;
        })

        return result
    },
    async GetAccessRules() {
        var result = await API.process(
            'api/Access/Rules',
            'GET',
            null
        ).catch((err) => {
            throw err;
        })

        return result
    },
    async UpsertAccessRule(Rule) {
        var result = await API.process(
            'api/Access/Rule',
            'POST',
            Rule
        ).catch((err) => {
            throw err;
        })

        return result
    },
    async DeleteAccessRules(RuleId) {
        var result = await API.process(
            `api/Access/Rule/${RuleId}`,
            'DELETE',
            null
        ).catch((err) => {
            throw err;
        })

        return result
    },
    async ListAccessRuleGrants(RuleID) {
        var result = await API.process(
            `api/Access/Rule/${RuleID}/Grants`,
            'GET',
            null
        ).catch((err) => {
            throw err;
        })

        return result
    },
    async UpsertAccessRuleGrant(RuleID, Grant) {
        var result = await API.process(
            `api/Access/Rule/${RuleID}/Grant`,
            'POST',
            Grant
        ).catch((err) => {
            throw err;
        })

        return result
    },
    async ListAccessRuleConsent(RuleID) {
        var result = await API.process(
            `api/Access/Rule/${RuleID}/Consent`,
            'GET',
            null
        ).catch((err) => {
            throw err;
        })

        return result
    },
    async UpsertAccessRuleConsent(RuleID, Consent) {
        var result = await API.process(
            `api/Access/Rule/${RuleID}/Consent`,
            'POST',
            Consent
        ).catch((err) => {
            throw err;
        })

        return result
    },
    async ApproveConsentRequest(RuleID, ConsentRequestID) {
        var result = await API.process(
            `api/Access/Rule/${RuleID}/Consent/${ConsentRequestID}/Approve`,
            'PUT',
            null
        ).catch((err) => {
            throw err;
        })

        return result
    },
    async DeclineConsentRequest(RuleID, ConsentRequestID) {
        var result = await API.process(
            `api/Access/Rule/${RuleID}/Consent/${ConsentRequestID}/Decline`,
            'PUT',
            null
        ).catch((err) => {
            throw err;
        })

        return result
    },
    async ListAccessRuleResources(RuleID) {
        var result = await API.process(
            `api/Access/Rule/${RuleID}/Resources`,
            'GET',
            null
        ).catch((err) => {
            throw err;
        })

        return result
    },
    async UpsertAccessRuleResource(RuleID, Resource) {
        var result = await API.process(
            `api/Access/Rule/${RuleID}/Consent`,
            'POST',
            Resource
        ).catch((err) => {
            throw err;
        })

        return result
    },
    async GetAvailableResources(AccessLevel) {
        var result = await API.process(
            `api/Access/Resources/Available${AccessLevel ? `?AccessLevel=${AccessLevel}` : ''}`,
            'GET',
            null
        ).catch((err) => {
            throw err;
        })

        return result
    },
    async GetAvailableResourcesByUserID(UserID, FacilityID, AccessLevel) {
        var result = await API.process(
            `api/Access/Resources/Available/${UserID}/${FacilityID}${AccessLevel ? `?AccessLevel=${AccessLevel}` : ''}`,
            'GET',
            null
        ).catch((err) => {
            throw err;
        })

        return result
    },
    async ListPendingRequests(showAll) {
        var result = await API.process(
            `api/Access/Requests/Pending${showAll ? '?showAll=true' : ''}`,
            'GET',
            null
        ).catch((err) => {
            throw err;
        })

        return result
    },
}
export default Access;